var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('nav-bar'),_c('div',{staticClass:"container-fluid"},[_c('message-center'),_c('router-view')],1),_c('loading-overlay')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }